import { proxy } from 'valtio';
import { getAgency as apiGetAgency } from '~/api/civilsearch';
import type { Agency, AgencyContact } from '~/common/types';

class Store {
  isLoading: boolean = false;
  isError: boolean = false;

  agency?: Agency;
  contacts: { [key: string]: AgencyContact } = {};
  subGeometries: { id: string; name: string | null }[] = [];

  async fetchData(id: string) {
    this.reset();

    try {
      this.isLoading = true;
      const { agency, contacts, subGeometries } = await apiGetAgency(id);

      this.agency = agency;
      this.subGeometries = subGeometries ?? [];

      contacts?.forEach((c) => {
        this.contacts[c.id] = c;
      });
    } catch {
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }

  reset() {
    this.isLoading = false;
    this.isError = false;
    this.agency = undefined;
    this.contacts = {};
    this.subGeometries = [];
  }
}

const store = proxy(new Store());
export default store;
